/**
 * Styled Components - Created by david on 09/04/18.
 */
import styled from 'styled-components'

export const Container = styled.div`
  background-color: #222;
`

export const Text = styled.div`
  color: #fff;
`

export const DragMessage = styled.div`
  color: #302628;
  font-size: 14px;
  line-height: 20px;
`

export const DragTypes = styled.div`
  color: #302628;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  margin-bottom: 10px;
`

export const Icon = styled.img`
  margin-bottom: 12px;
  filter: brightness(0);
  max-width: 34px;
  width: 100%;
`

export const PreviewImage = styled.img`
  width: 100%;
  height: 194px;
`

export const buttonStyle = {
  width: '20%',
  margin: '16px 0px'
}

export const draggerStyle = { padding: '30px 0px' }



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/TeamDragger/styledComponents.tsx